module.exports = __webpack_public_path__ + "static/media/create-and-share.f7ccc5fb.jpg";